import {
  checkEmpty,
  checkSocRange,
} from "./fieldValidator";

function composeValidators(validators) {
  return function (value) {
    for (let i = 0; i < validators.length; i++) {
      const error = validators[i](value);
      if (error) return error;
    }
    return null;
  };
}

const validatorRegistry = {
  cost_up: composeValidators([checkEmpty,]),
  cost_down: composeValidators([checkEmpty,]),
  min_energy: composeValidators([checkEmpty,]),
  max_energy: composeValidators([checkEmpty,]),
  initial_soc: composeValidators([checkEmpty, checkSocRange]),
  terminal_soc: composeValidators([checkEmpty, checkSocRange]),
  objective: composeValidators([checkEmpty]),
};

export default validatorRegistry;
